import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import { useFormik } from "formik";
import EyeOffOutline from "mdi-react/EyeOffOutlineIcon";
import EyeOutline from "mdi-react/EyeOutlineIcon";
import { useState } from "react";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import ModalLoader from "../utils/ModalLoader";

import { useAuth } from "../../hooks/useAuth";
import { initialValues, schemaLogin } from "./types";
import "../../assets/scss/new-entity-modal.scss";
import { isEmpty } from "lodash";
import { backendApis } from "../../config";
import { useStoreState } from "easy-peasy";

export const LoginCustomerPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { customerBackendUrl: backendUrl, loginCustomer } = useAuth();
  const generalSettings = useStoreState((state) => state.generalSettings);

  const loginUser = async (values) => {
    let response = await fetch(`${backendUrl}/api/customers/login`, {
      method: "POST",
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
      body: JSON.stringify({
        ...values,
      }),
      credentials: "include",
    });

    if (!response.ok) {
      response = await response.json();
      if (response.errors) formik.setErrors(response.errors);
      throw new Error(response.message);
    }

    return await response.json();
  };

  const createCustomerMutation = useMutation((payload) => loginUser(payload), {
    onSuccess: (data) => {
      const isAccessEnabled =
        generalSettings?.enableUnverifiedCustomersOnlineStoreAccess;
      const isVerified = data?.user?.isVerified;

      if (!isAccessEnabled) {
        if (!Boolean(isVerified)) {
          toast.warning("Please verify your account");
          return;
        }
      }
      loginCustomer(data?.user, location);
      toast.success("Login Successfully");

      navigate("/store/account/dashboard");

      // if (props.loggedInCustomer) props.loggedInCustomer(data?.user);
      // props?.onHide();
    },
    onError: (errors) => {
      console.log(errors);
    },
  });

  const formik = useFormik({
    initialValues,
    validationSchema: schemaLogin,
    onSubmit: (values) => {
      createCustomerMutation.mutate({
        ...values,
      });
    },
  });

  const verify = async (values) => {
    let response = await fetch(`${backendUrl}/api/auth/send-verify-mail`, {
      method: "POST",
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
      body: JSON.stringify({
        ...values,
      }),
      credentials: "include",
    });

    if (!response.ok) {
      response = await response.json();
      if (response.errors) formik.setErrors(response.errors);
      throw new Error(response.message);
    }

    return await response.json();
  };

  const verificationMutation = useMutation((payload) => verify(payload), {
    onSuccess: (data) => {
      toast.success("Mail Sent");
    },
    onError: (errors) => {
      // console.log(errors);
      toast.error("Error sending Mail");
    },
  });

  const sendVerificationMail = () => {
    if (isEmpty(formik.values.Email)) {
      formik.setFieldError("Email", "Required");
      return;
    }
    verificationMutation.mutate({
      ...formik.values,
      companyName: backendApis.find((el) => el.isStore)?.name,
      // companyName: authUser.company
    });
  };

  return (
    <>
      <div
        className=" d-flex flex-column justify-content-center align-items-center mx-auto my-auto w-100  "
        style={{ maxWidth: "35rem", height: "80vh" }}
      >
        <div className=" w-100 border rounded-3  p-4 m-1">
          <div className=" w-100 mb-3">
            <div>
              <h4>Login</h4>
              <p>Login by filling in the following forms.</p>
            </div>
          </div>
          <div className=" w-100">
            <div className="px-1">
              <Form
                noValidate
                onSubmit={formik.handleSubmit}
                autoComplete="off"
              >
                {/*  */}
                <Form.Group className="mb-3 pb-2">
                  <Form.Label className="mb-1">Email Address</Form.Label>
                  <Form.Control
                    className=""
                    type="email"
                    placeholder="Enter email"
                    name="Email"
                    value={formik.values.Email}
                    onChange={formik.handleChange}
                    isInvalid={formik.touched.Email && !!formik.errors.Email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.Email}
                  </Form.Control.Feedback>
                </Form.Group>
                {/*  */}
                <Form.Group className="mb-4">
                  <Form.Label>Password</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="*****"
                      value={formik.values.password}
                      onChange={formik.handleChange}
                      isInvalid={
                        formik.touched.password && !!formik.errors.password
                      }
                    />
                    {showPassword ? (
                      <InputGroup.Text
                        onClick={() => setShowPassword(false)}
                        className="bg-white"
                      >
                        <EyeOutline />
                      </InputGroup.Text>
                    ) : (
                      <InputGroup.Text
                        onClick={() => setShowPassword(true)}
                        className="bg-white"
                      >
                        <EyeOffOutline />
                      </InputGroup.Text>
                    )}
                  </InputGroup>

                  {formik.errors.password && (
                    <span className="text-danger">
                      {formik.errors.password}
                    </span>
                  )}
                </Form.Group>

                {/*  */}
                <div className="d-flex justify-content-end">
                  <button className="btn btn-primary w-100 p-3" type="submit">
                    Login
                  </button>
                </div>
              </Form>
            </div>

            <Button
              onClick={() => sendVerificationMail()}
              variant=""
              className="text-primary text-xs forgot py-1 my-2 text-center"
              type="button"
              style={{ fontSize: "0.75rem" }}
              disabled={verificationMutation.isLoading}
            >
              {verificationMutation.isLoading
                ? "Sending..."
                : "Send Verification Mail"}
            </Button>
          </div>
        </div>
      </div>
      <ModalLoader show={createCustomerMutation.isLoading} />
    </>
  );
};
